import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PublicIcon from '@mui/icons-material/Public';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.scss';
import { languages } from '../../utils/constants';
import colors from '../../scss/colors';

function LanguageSwitcher({ gap = '10px' }) {
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const { i18n } = useTranslation();
  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    const language = languages.find((lg) => lg.key === lang);
    window.sessionStorage.setItem('lang', lang);
    setSelectedLanguage(language.key);
  };
  const locale = window.sessionStorage.getItem('lang');

  const selectStyled = {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiSelect-select': {
      marginTop: 1,
      padding: '0px',
      paddingRight: '10px !important',
      paddingLeft: gap,
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '16px',
      color: colors.NAVY_BLUE,
      fontFamily: 'Gotham-Book'
    },
    '@media only screen and (max-width: 997px)': {
      paddingLeft: '0px',
      paddingTop: '8px',
      paddingBottom: '8px'
    }
  };

  useEffect(() => {
    if (!locale) return;
    setSelectedLanguage(locale);
    i18n.changeLanguage(locale);
  }, [locale]);

  return (
    <div className={`${styles.language_switcher} h-100`}>
      <FormControl className={styles.formControl}>
        <Select
          value={selectedLanguage}
          onChange={(event) => handleLanguageChange(event.target.value)}
          startAdornment={<PublicIcon />}
          inputProps={{ 'aria-label': 'Without label' }}
          IconComponent=""
          sx={selectStyled}
        >
          {languages
            ? languages.map((lang) => (
                <MenuItem key={lang.key} value={lang.key}>
                  {lang.value}
                </MenuItem>
              ))
            : null}
        </Select>
      </FormControl>
    </div>
  );
}
export default LanguageSwitcher;
